import { sortByListOrder } from './assignListOrder';

export type AssignSnapshot = {
    title: string;
    sublabel?: string;
};

export function isAssignedItemActive(
    id: number,
    activeIdSet: ReadonlySet<number>,
    explicitActive?: boolean
): boolean {
    if (explicitActive !== undefined) {
        return explicitActive;
    }
    return activeIdSet.has(id);
}

export function sortAttachedByOrder<T extends { list_order: number }>(items: T[]): T[] {
    return sortByListOrder(items);
}

export function filterActiveForAssignPayload<T extends { list_order: number }>(
    attached: T[],
    activeIdSet: ReadonlySet<number>,
    getId: (item: T) => number,
    explicitActiveById?: ReadonlyMap<number, boolean>
): T[] {
    return sortAttachedByOrder(attached).filter((item) => {
        const id = getId(item);
        const explicit = explicitActiveById?.get(id);
        return isAssignedItemActive(id, activeIdSet, explicit);
    });
}

export function resolveAssignedRowDisplay(
    id: number,
    activeIdSet: ReadonlySet<number>,
    activeLookup: ReadonlyMap<number, AssignSnapshot>,
    snapshot: AssignSnapshot | undefined,
    explicitActive?: boolean
): { title: string; sublabel?: string; isActive: boolean } {
    const isActive = isAssignedItemActive(id, activeIdSet, explicitActive);
    const fromActive = activeLookup.get(id);

    if (fromActive) {
        return { title: fromActive.title, sublabel: fromActive.sublabel, isActive };
    }

    return {
        title: snapshot?.title ?? `Item #${id}`,
        sublabel: snapshot?.sublabel,
        isActive,
    };
}

export function buildActiveLookup<T>(
    items: T[],
    getId: (item: T) => number,
    getTitle: (item: T) => string,
    getSublabel?: (item: T) => string | undefined
): Map<number, AssignSnapshot> {
    const lookup = new Map<number, AssignSnapshot>();
    for (const item of items) {
        lookup.set(getId(item), {
            title: getTitle(item),
            sublabel: getSublabel?.(item),
        });
    }
    return lookup;
}
